export default "__VITE_ASSET__350065a0__"